// product list
export const COUNTRY_DETAIL_GET_REQUEST = 'COUNTRY_DETAIL_GET_REQUEST';
export const COUNTRY_DETAIL_GET_SUCCESS = 'COUNTRY_DETAIL_GET_SUCCESS';
export const COUNTRY_DETAIL_GET_ERROR = 'COUNTRY_DETAIL_GET_ERROR'; 
